module.exports = __webpack_public_path__ + "static/media/SendMail.f7214f89.svg";